var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blog-content-section',{attrs:{"content":_vm.attributes.content,"published-at":_vm.attributes.__page.published_at}})}
var staticRenderFns = []

export { render, staticRenderFns }